import { Space } from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-sdk/components'
import {
  useCollections,
  useNetwork,
  useSpace,
  useUpdateSpace,
} from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

import { SpaceImage } from '../../../Space/SpaceImage'

export const SpaceSettingsGeneral = ({ space }: { space: Space }) => {
  const { data: network } = useNetwork()
  const { data: collections } = useCollections()
  const { data } = useSpace({
    variables: {
      id: space.id,
    },
    fields: {
      authMemberProps: 'all',
      image: 'basic',
      collection: 'basic',
    },
  })
  const { mutateAsync: updateSpace, isLoading } = useUpdateSpace()

  if (data) space = data

  return (
    <>
      <Form
        defaultValues={{
          ...space,
          collectionId: space?.collection?.id,
        }}
        onSubmit={async data => {
          const { name, description, slug, collectionId } = data
          try {
            await updateSpace({
              id: space?.id,
              input: {
                name,
                description,
                slug,
                collectionId,
              },
            })
            toast({
              title: 'Space updated',
              status: 'success',
            })
          } catch (e) {
            toast({
              title: 'Unable to update space',
              status: 'error',
            })
          }
        }}
      >
        <div className="col-span-12 md:col-span-8 flex flex-col space-y-5">
          <h2>Settings</h2>
          <div>
            <FormControl.Label>Icon</FormControl.Label>
            <SpaceImage space={space} size="lg" readOnly={false} />
          </div>
          <Form.Input
            label="Name"
            name="name"
            validation={{
              required: 'Space name cannot be empty.',
            }}
          />
          <Form.Textarea label="Description" name="description" />
          <Form.Input
            label="Web address"
            name="slug"
            leadingAddon={`${network?.domain}/`}
          />
          <Form.Select
            label="Collection"
            name="collectionId"
            items={collections?.map(collection => ({
              text: collection?.name,
              value: collection?.id,
            }))}
          />
          <Form.Actions>
            <Button type="submit" loading={isLoading}>
              Update
            </Button>
          </Form.Actions>
        </div>
      </Form>
    </>
  )
}
